import merge from "lodash/merge";
import { ISeriesPrimitiveAxisView } from 'lightweight-charts'
export type LabelledVerticalLineAxisLabelViewOptions = {
    xCoordinate: number,
    text: string,
    textColor: string,
    labelColor: string
}

class LabelledVerticalLineAxisLabelView implements ISeriesPrimitiveAxisView {
    id: string
    options: LabelledVerticalLineAxisLabelViewOptions

    constructor(options: LabelledVerticalLineAxisLabelViewOptions) {
        this.options = options;
    }

    setOptions(options: Partial<LabelledVerticalLineAxisLabelViewOptions>) {
        this.options = merge(this.options, options);
    }

    coordinate(): number {
        return this.options.xCoordinate;
    }

    text(): string {
        return this.options.text;
    }

    textColor(): string {
        return this.options.textColor
    }

    backColor(): string {
        return this.options.labelColor
    }

}


export default LabelledVerticalLineAxisLabelView